import { createSlice } from "@reduxjs/toolkit";
import { appRouterPaths } from "@/services/navigation";
import type { ContactsTabsState } from "../types";

const initialState: ContactsTabsState = {
  activeTab: appRouterPaths.contacts.genInfo,
  isEditMode: false,
};

const contactsTabsSlice = createSlice({
  name: "contactsTabs",
  initialState,
  reducers: {
    setActiveTab: (state, action) => {
      state.activeTab = action.payload;
    },
    setIsEditMode: (state, action) => {
      state.isEditMode = action.payload;
    },
  },
  selectors: {
    selectActiveTab: (state) => state.activeTab,
    selectIsEditMode: (state) => state.isEditMode,
  },
});

export const {
  actions: contactsTabsActions,
  reducer: contactsTabsReducer,
  selectors: contactsTabsSelectors,
} = contactsTabsSlice;
